'use client';
import { SectionContainer } from '../component/SectionContainer';
import Tabs, { TabPane } from '../_bs-components/TabCarousel';
import TabTitle from '../_bs-components/TabTitle';
import { AgendaReviewItem } from '../type';
import { getCMSIntlVal } from '../utils/common';
import { useLocale } from 'use-intl';
import { useMedia } from '@ssv-website/hooks';
import AgendaCardGrid from '../_bs-components/AgendaCardGrid';

export default function MeetingAgendaReviewSection({
  data,
  title,
}: {
  data: AgendaReviewItem[];
  title: string;
}) {
  const defaultKey = data[0].id;
  const locale = useLocale();
  const isMobile = useMedia('mobile');
  return (
    <SectionContainer
      title={<span>{title}</span>}
      titleClassName="mobile:!mb-4"
      contentClassName="mobile:max-w-full mobile:!px-0"
    >
      <Tabs
        activeKey={defaultKey}
        disableDrag={true}
        openSticky={isMobile}
        stickyOffset={60}
        titleClassName="mobile:top-12 bg-[#EDF3FF]"
        titleScrollClassName="mobile:ml-5"
        titleContentClassName="mobile:mr-5"
        paneScrollClassName="mobile:ml-5"
      >
        {data.map((item) => {
          const { meetingList } = item;
          const name = getCMSIntlVal(item, 'name', locale);
          const desc = getCMSIntlVal(item, 'desc', locale);
          return (
            <TabPane
              key={item.id}
              tabKey={item.id}
              title={({ isActive }) => {
                return (
                  <TabTitle title={name} subTitle={desc} isActive={isActive} />
                );
              }}
            >
              <AgendaCardGrid list={meetingList}></AgendaCardGrid>
            </TabPane>
          );
        })}
      </Tabs>
    </SectionContainer>
  );
}
